export const GET_LISTING_TYPES = '[Property Type Action] Get listing types';
export const CONFIRMED_GET_LISTING_TYPES = '[Property Type Action] Confirmed Get listing types';
